import { fetchAssignableProjectsService } from "../../project/service/project-service";

export interface UserProjectAccessOption {
    label: string;
    value: string;
}

export abstract class AbstractSecretariaProjectAccessController {
    protected mapOptions(items: any[] = []): UserProjectAccessOption[] {
        return items.map(({ name, id }: any) => ({ label: name, value: id }));
    }

    protected hasRoleName(role: any, roleName: string) {
        return (role?.label || "").toLowerCase() === roleName.toLowerCase();
    }

    isSecretariaRole(roleId: string | undefined, roles: any[] = []) {
        return roles.some((role) => role.value === roleId && this.hasRoleName(role, "secretaria"));
    }

    ensureCompanyForMaster(isMaster: boolean, selectedCompanyId?: string | null) {
        if (isMaster && !selectedCompanyId) {
            throw new Error("Selecione a empresa da secretaria");
        }
    }

    ensureProjectSelection(roleId: string | undefined, roles: any[] = [], projectIds: string[] = []) {
        if (this.isSecretariaRole(roleId, roles) && !projectIds.length) {
            throw new Error("Selecione ao menos um projeto para a secretaria");
        }
    }

    async loadProjectOptions(companyId?: string) {
        const projects = await fetchAssignableProjectsService(companyId);
        return this.mapOptions(projects || []);
    }
}

export class SecretariaProjectAccessController extends AbstractSecretariaProjectAccessController {}

export default SecretariaProjectAccessController;
